// MarkButton.jsx
import React from "react";
import getMarkButtonProps from "./getMarkButtonProps";
import { useGame } from "../../components/newgame/context/GameContext";

const MarkButton = ({
    question,
    isMarked,
    loading,
    language,
    videoBtnDisabled,
    pdfBtnDisabled,
    selectedOptions,
    selectedOptionsMcq,
    CheckIkagiValues,
    snakeLadderWon,
    wrongBucket,
    rightBucket,
    buckets,
    dragDropLength,
    currentPage,
    totalCount,
    setShowResult1,
    setShowResult2,
    MarkAsDoneQuiz,
    translationData
}) => {
    const { state, dispatch } = useGame();
    const { stats: flipGameStats } = state;
    const props = getMarkButtonProps({
        question,
        isMarked,
        loading,
        language,
        videoBtnDisabled,
        pdfBtnDisabled,
        selectedOptions,
        selectedOptionsMcq,
        CheckIkagiValues,
        snakeLadderWon,
        wrongBucket,
        rightBucket,
        buckets,
        dragDropLength,
        currentPage,
        totalCount,
        setShowResult1,
        setShowResult2,
        MarkAsDoneQuiz,
        flipGameStats,
        translationData
    });

    if (!props) return null;

    const {
        label,
        style,
        onClick,
        className = "d-flex align-items-center gap-2",
        disabled,
        loading: btnLoading,
    } = props;

    return (
        <div className="markButtons">
            <button
                onClick={onClick}
                className={className}
                style={style}
                disabled={disabled}
            >
                {label}
                {btnLoading && (
                    <span
                        className="spinner-border spinner-border-sm"
                        aria-hidden="true"
                    ></span>
                )}
            </button>
        </div>
    );
};

export default MarkButton;
